import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IFormConfigSectionQualifier } from "./FormConfigSectionQualifier";

export interface TSection {
  id: number;
  valid: boolean;
  orderNumber: number;
  orderNumberVisible: boolean;
  name: string;
  label: string;
  labelVisible: boolean;
  formTypeCode: string;
  description: string;
  comment: string;
  formSectionId?: number;
  sqlValidation: string;
  maxNumber: number;
  subsections: ISection[];
  qualifiers: IFormConfigSectionQualifier[];
  required: boolean;
  portalAggregate:boolean;
}

export interface ISection extends TSection {}

const Section = Model(
  (model: TSection): ISection => {
    const _section: TSection = Object.assign({}, model);

    let create = (section: ISection): ISection => {
      let obj = ValidatableObject(section);
      return obj;
    };

    let section = {
      get id() {
        return _section.id;
      },
      set id(value) {
        _section.id = value;
      },
      get valid() {
        return _section.valid;
      },
      set valid(value) {
        _section.valid = value;
      },
      get orderNumber() {
        return _section.orderNumber;
      },
      set orderNumber(value) {
        _section.orderNumber = value;
      },
      get orderNumberVisible() {
        return _section.orderNumberVisible;
      },
      set orderNumberVisible(value) {
        _section.orderNumberVisible = value;
      },
      get name() {
        return _section.name;
      },
      set name(value) {
        _section.name = value;
      },
      get label() {
        return _section.label;
      },
      set label(value) {
        _section.label = value;
      },
      get labelVisible() {
        return _section.labelVisible;
      },
      set labelVisible(value) {
        _section.labelVisible = value;
      },
      get formTypeCode() {
        return _section.formTypeCode;
      },
      set formTypeCode(value) {
        _section.formTypeCode = value;
      },
      get description() {
        return _section.description;
      },
      set description(value) {
        _section.description = value;
      },
      get comment() {
        return _section.comment;
      },
      set comment(value) {
        _section.comment = value;
      },
      get formSectionId() {
        return _section.formSectionId;
      },
      set formSectionId(value) {
        _section.formSectionId = value;
      },
      get sqlValidation() {
        return _section.sqlValidation;
      },
      set sqlValidation(value) {
        _section.sqlValidation = value;
      },
      get maxNumber() {
        return _section.maxNumber;
      },
      set maxNumber(value) {
        _section.maxNumber = value;
      },
      get subsections() {
        return _section.subsections;
      },
      set subsections(value) {
        _section.subsections = value;
      },
      get qualifiers() {
        return _section.qualifiers;
      },
      set qualifiers(value) {
        _section.qualifiers = value;
      },
      get required() {
        return _section.required;
      },
      set required(value) {
        _section.required = value;
      },
      get portalAggregate(){
        return _section.portalAggregate;
      },
      set portalAggregate(value){
        _section.portalAggregate = value
      }
    };
    return create(section);
  }
);

export default Section;
